export default "__VITE_ASSET__BSG2xmYw__"